import script from "./assiginments.vue?vue&type=script&setup=true&lang=js"
export * from "./assiginments.vue?vue&type=script&setup=true&lang=js"

import "./assiginments.vue?vue&type=style&index=0&id=2e91b0a5&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e91b0a5"]])

export default __exports__